import React, { useState } from 'react';
import DynamicFieldsWrapper from './dynamic-fields/dynamic-fields-wrapper';
import { FormProvider, useForm } from 'react-hook-form';
import axios from 'axios';
import { UPDATE_CUSTOM_FIELD_ANSWERS } from '../../../../constants/custom-field-endpoint';

function CustomFieldsAnswers({ answers }) {

    //props
    const methods = useForm();
    const { register, control, reset, handleSubmit } = methods;
    const [requestLoader, setRequestLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isEdit, setIsEdit] = useState(false);

    //methods
    const updateAnswers = (formValues) => {
        const fieldAnswers = formValues?.field_answers?.flatMap(it => it.answers);
        setRequestLoader(true);
        axios.put(UPDATE_CUSTOM_FIELD_ANSWERS, fieldAnswers)
        .then((res) => {
            setRequestLoader(false);
            if(res?.data?.status){
                setIsEdit(false);
                window.location.reload();
            }else{
                setErrorMessage(res?.data?.message);
            }
        }).catch((error) => {
            setRequestLoader(false);
            setErrorMessage("Failed to update answers!");
        })
    }

    return (
        <div className="col-xxl-4">
            <div className="card">
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(updateAnswers)}>
                        <div className="card-body">
                            <div className="col-12 border-bottom"><div className="d-flex justify-content-between">
                                <h6 className="text-bold mb-0">Additional Information</h6>
                                <button
                                disabled={requestLoader}
                                onClick={(event) => {
                                    if (!isEdit) {
                                        event.preventDefault();
                                        setIsEdit(true);
                                    }
                                }}
                                 type={isEdit ? 'submit' : 'button'} 
                                 className={`${requestLoader ? 'position-relative button--loading' : ''} btn btn-outline-primary mb-2 pt-1 pb-1`}>{isEdit ? 'Save' : 'Edit'}</button> 
                            </div>
                            </div>
                            {
                                (isEdit && answers?.length > 0) ?
                                    <DynamicFieldsWrapper
                                        entityInfo={{
                                            entity_id: 'e6c3dc7e-1c9b-4982-9d8c-b5d992848c5d'
                                        }}
                                        isTitle={false}
                                        control={control} fieldList={answers} /> : !isEdit ?
                                        <dl className="text-black mt-2 mb-0">
                                            {
                                                answers?.map((item, index) => {
                                                    return <div key={`donation_answer_${index}`} >
                                                        <dt className="d-flex justify-content-between align-items-center">
                                                            <span>{item?.field_label}</span>
                                                        </dt>
                                                        <dd>
                                                            {
                                                                item?.answers[0]?.text_value ?
                                                                    item?.answers[0]?.text_value :
                                                                    (item?.answers[0]?.boolean_value || item?.answers[0]?.boolean_value === 0) ?
                                                                        (item?.answers[0]?.boolean_value === 0 ? 'No' : 'Yes') :
                                                                        item?.answers[0]?.number_value ?
                                                                            item?.answers[0]?.number_value :
                                                                            item?.answers[0]?.date_value ?
                                                                                item?.answers[0]?.date_value :
                                                                                item?.answers[0]?.string_value ?
                                                                                    item?.answers[0]?.string_value : ''
                                                            }
                                                        </dd>
                                                    </div>
                                                })
                                            }
                                        </dl> : ''
                            }
                            {
                                errorMessage ?
                                    <p className='text-danger'>Failed to save</p> : ''
                            }

                        </div>
                    </form>
                </FormProvider>

            </div>
        </div>
    );
}

export default CustomFieldsAnswers;